import Icon from './Icon'
import PaginatorPage from './PaginatorPage'
import PaginatorPageGap from './PaginatorPageGap'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import _ from 'underscore'
import { KeyCodes } from '../constants/appConstants'
import React, { PureComponent } from 'react'
import styled from '@emotion/styled'

const Label = styled.span({
  fontSize: 14,
  fontStyle: 'italic',
  fontWeight: 'bold',
  marginLeft: 10,
  marginRight: 10,
  verticalAlign: 'middle'
})

export default class Paginator extends PureComponent {
  static propTypes = {
    allowInput: PropTypes.bool,
    className: PropTypes.string,
    leadingPages: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    style: PropTypes.object,
    totalPages: PropTypes.number.isRequired,
    trailingPages: PropTypes.number
  }

  static defaultProps = {
    allowInput: false,
    leadingPages: 3,
    page: 1,
    totalPages: 1,
    trailingPages: 3
  }

  constructor(props) {
    super(props)

    this.handleKeyUp = this.handleKeyUp.bind(this)
  }

  handleKeyUp(e) {
    const { totalPages } = this.props

    if (e.which === KeyCodes.ENTER) {
      const page = parseInt(e.target.value, 10)

      if (page > 0 && page <= totalPages) {
        this.selectPage(page)
        this.input.value = ''
        this.input.blur()
      }
    }
  }

  renderPage(page) {
    return (
      <PaginatorPage
        key={page}
        page={page}
        selected={false}
        onClick={() => this.selectPage(page)}
      />
    )
  }

  selectPage(page) {
    if (page !== this.props.page) {
      this.props.onChange(page)
    }
  }

  leadingPageNumbers() {
    const { leadingPages, page } = this.props
    return _.last(_.range(1, page), leadingPages)
  }

  trailingPageNumbers() {
    const { page, totalPages, trailingPages } = this.props
    return _.first(_.range(page + 1, totalPages), trailingPages)
  }

  renderLeadingGap() {
    const { leadingPages } = this.props
    if (this.leadingPageNumbers()[0] > leadingPages - 1) {
      return <PaginatorPageGap />
    }
  }

  renderTrailingGap() {
    const { totalPages, trailingPages } = this.props
    if (this.trailingPageNumbers()[0] < totalPages - trailingPages) {
      return <PaginatorPageGap />
    }
  }

  renderFirstPage() {
    const { page } = this.props
    if (page !== 1 && this.leadingPageNumbers()[0] !== 1) {
      return this.renderPage(1)
    }
  }

  renderLastPage() {
    const { page, totalPages } = this.props

    if (page !== totalPages) {
      return this.renderPage(totalPages)
    }
  }

  renderPrevious() {
    const { page } = this.props
    let visibility

    let onClick = this.selectPage.bind(this, page - 1)

    if (page === 1) {
      visibility = 'hidden'
      onClick = () => {} // noop
    }

    return (
      <span data-qv-pagination="prev page">
        <a onClick={onClick} style={{ visibility: visibility }}>
          <Icon name="chevron-left" />
        </a>
      </span>
    )
  }

  renderNext() {
    const { page, totalPages } = this.props
    let visibility

    let onClick = this.selectPage.bind(this, page + 1)

    if (page === totalPages) {
      visibility = 'hidden'
      onClick = () => {} // noop
    }

    return (
      <span data-qv-pagination="next page">
        <a onClick={onClick} style={{ visibility: visibility }}>
          <Icon name="chevron-right" />
        </a>
      </span>
    )
  }

  render() {
    const { allowInput, className, page, style, totalPages } = this.props

    if (totalPages <= 1) {
      return <nav data-qv-pagination="" />
    }

    const classes = classNames('pagination', className)

    return (
      <nav data-qv-pagination={classes} style={style}>
        {this.renderPrevious()}
        {this.renderFirstPage()}
        {this.renderLeadingGap()}
        {this.leadingPageNumbers().map(this.renderPage, this)}
        <PaginatorPage selected={true} page={page} />
        {this.trailingPageNumbers().map(this.renderPage, this)}
        {this.renderTrailingGap()}
        {this.renderLastPage()}
        {this.renderNext()}
        {allowInput && <Label>{I18n.t('Go to page:')}</Label>}
        {allowInput && (
          <input
            ref={input => {
              this.input = input
            }}
            type="text"
            onKeyUp={this.handleKeyUp}
            css={`
              width: 55px !important;
              height: 24px !important;
              border-radius: 2px !important;
            `}
          />
        )}
      </nav>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/Paginator.js